import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useValidationAES from '../hooks/useValidationAES'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import { useInitializerTransportValidations } from '../hooks/useInitializerTransportValidations'
import { fieldPatterns } from '../util/fieldPatterns'
import { useInitializePartiesValidations } from '../hooks/useInitializerPartiesValidations'
import { useInitializeHeaderValidations } from '../hooks/useInitializerHeaderValidations'




const ErrorInitializer = ({ children, translate }) => {
  const dispatch = useDispatch()
  const { isImportShipment } = useCurrentShipmentType()
  const validationPattern=fieldPatterns(isImportShipment,translate)
  const {headerTabValidatonInit} = useInitializeHeaderValidations("headerTab",validationPattern)
  const {initPartiesTabValidation,repeatableValidationMethodsParties} = useInitializePartiesValidations("parties",validationPattern,translate)  
  const {initTransportTabValidation,repeatableValidationMethodsTransport} = useInitializerTransportValidations("transportTab",validationPattern,translate) 
  const { initHeaderTabValidation,initItemsTabValidation } = useValidationAES(isImportShipment,translate)

  useEffect(() => {
    dispatch(headerTabValidatonInit())
    dispatch(initHeaderTabValidation())
    dispatch(initTransportTabValidation())
    dispatch(initPartiesTabValidation())
    dispatch(initItemsTabValidation())
  }, [translate])

  return children && children({repeatableValidationMethodsParties,repeatableValidationMethodsTransport})
}

export default React.memo(ErrorInitializer)
